// extracted by mini-css-extract-plugin
export default {"link":"RO-z","disabled":"SO-z"};